export default __webpack_public_path__ + "static/media/7_map2.820c69ca.png";